var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 = _vm.item.bbs_status != 2 ? _vm.item.comments.length : null
  var g1 = _vm.item.bbs_status != 2 ? _vm.item.comments.length : null
  var g2 = !(_vm.item.bbs_status != 2) ? _vm.item.comments.length : null
  var f0 = _vm._f("timeFrom")(_vm.item._add_time)
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
        g1: g1,
        g2: g2,
        f0: f0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }